module.exports = __webpack_public_path__ + "img/qingjia.8df04866.png";